// extracted by mini-css-extract-plugin
export default {"modal":"CompletPay_modal__zJqiI","title":"CompletPay_title__eMyGW","complete":"CompletPay_complete__03E+P","float":"CompletPay_float__aGAOv"};